<template>
  <PageContainer
    v-if="authStore.authenticated"
    :showGlobalSideMenu="authStore.registered && !authStore.inOnboarding"
    :display-back-button="routerHelperStore.displayBackButton"
    :display-questionnaire-progress-bar="
      routerHelperStore.showQuestionnaireProgressBar
    "
  >
    <router-view />
  </PageContainer>
  <LoginPageContainer v-else-if="isLoginPage">
    <router-view />
  </LoginPageContainer>
  <PublicPageContainer v-else>
    <router-view />
  </PublicPageContainer>
</template>

<script setup lang="ts">
import PageContainer from "@/components/containers/PageContainer.vue";
import PublicPageContainer from "@/components/containers/PublicPageContainer.vue";
import LoginPageContainer from "@/components/containers/LoginPageContainer.vue";
import { useAuthenticationStore } from "@/stores/authentication";
import { useRouterHelper } from "@/stores/routerHelper";
import { useRouter } from "vue-router";
import { RouterPath } from "@/models/enum/routerPath";

const authStore = useAuthenticationStore();
const routerHelperStore = useRouterHelper();
const router = useRouter();

const isLoginPage =
  router.currentRoute.value.name === RouterPath.Login ||
  router.currentRoute.value.name === undefined;
</script>

<!-- Temporary styling - need to fix some Vuetify 3 components to allow spinners and tooltips -->
<style>
.v-icon:hover {
  cursor: pointer;
}
</style>
